module.exports = __webpack_public_path__ + "static/media/product-standard-photo.11eeefa9.svg";